import { Bell, Zap } from 'lucide-react'
import { AlertHistoryTable } from '@/components/alerts/alert-history-table'
import { AlertRulesTable } from '@/components/alerts/alert-rules-table'
import { LoadingPage } from '@/components/ui/loading'
import { useAlertRules, useTestAlert } from '@/hooks/use-alerts'

export function AlertsPage(): React.JSX.Element {
  const rulesQuery = useAlertRules()
  const testAlert = useTestAlert()

  if (rulesQuery.isLoading) {
    return <LoadingPage message="Loading alert configuration..." />
  }

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Bell className="h-6 w-6 text-admin-500" />
          <h1 className="text-2xl font-semibold text-text-primary">Alerts & Notifications</h1>
        </div>
        <button
          type="button"
          onClick={() => testAlert.mutate()}
          disabled={testAlert.isPending}
          className="inline-flex items-center gap-2 rounded-lg bg-admin-500 px-4 py-2 text-sm font-medium text-white hover:bg-admin-600 disabled:opacity-50"
        >
          <Zap className="h-4 w-4" />
          {testAlert.isPending ? 'Sending...' : 'Test Alert'}
        </button>
      </div>

      <section>
        <h2 className="mb-3 text-sm font-medium text-text-primary">Alert Rules</h2>
        <AlertRulesTable rules={rulesQuery.data ?? []} isLoading={rulesQuery.isLoading} />
      </section>

      <section>
        <AlertHistoryTable />
      </section>
    </div>
  )
}
